export const mediaLimit = 20;
export const mediaPageList = [10, 20, 30, 40, 50];